module.exports = __webpack_public_path__ + "img/facility.20c6929c.png";